import { render, staticRenderFns } from "./TagPreview.vue?vue&type=template&id=36fb4e8a&scoped=true"
import script from "./TagPreview.vue?vue&type=script&lang=ts"
export * from "./TagPreview.vue?vue&type=script&lang=ts"
import style0 from "./TagPreview.vue?vue&type=style&index=0&id=36fb4e8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fb4e8a",
  null
  
)

export default component.exports